export default "__VITE_ASSET__DxmX5el6__"